import request from '@/utils/request'

/**
 * @param parameter
 * @returns {*}
 */
export function login(data) {
  return request({
    url: '/bohu-bms-backend/login',
    method: 'post',
    data
  })
}

export function getCheckUuid(checkUuid = '') {
  return request({
    url: `/bohu-bms-backend/getCheckUuid?checkUuid=${checkUuid}`,
    method: 'get'
  })
}

// 获取短信验证码
export function getVerificationCode(params) {
  return request({
    url: '/bohu-bms-backend/getCode',
    method: 'get',
    params
  })
}

// 查询用户数据
export function getUserData() {
  return request({
    url: '/bohu-bms-backend/access/user/user-data',
    method: 'get'
  })
}

export function logout(data) {
  return request({
    url: '/bohu-bms-backend/logout',
    method: 'post',
    data
  })
}

/**
 * 修改基础信息
 * @param
 * @returns {*}
 */
export function updBaseInfo(data) {
  return request({
    url: '/bohu-bms-backend/access/user/updBaseInfo',
    method: 'post',
    data
  })
}

/**
 * 修改密码
 * @param data
 * @returns {*}
 */
export function updatePwd(data) {
  return request({
    url: '/bohu-bms-backend/access/user/updPassword',
    method: 'post',
    data
  })
}

